module.exports = __webpack_public_path__ + "static/media/junk-is-no-good-baby.174ebf7a.txt";